declare namespace $ {

	type $mol_grid_cell__attr_shm_showcase_table_1 = $mol_type_enforce<
		({ 
			'column': ReturnType< $shm_showcase_table['cell_column'] >,
		})  & ReturnType< $mol_grid_cell['attr'] >
		,
		ReturnType< $mol_grid_cell['attr'] >
	>
	type $mol_grid_cell__sub_shm_showcase_table_2 = $mol_type_enforce<
		ReturnType< $shm_showcase_table['cell_content'] >
		,
		ReturnType< $mol_grid_cell['sub'] >
	>
	type $mol_link__title_shm_showcase_table_3 = $mol_type_enforce<
		ReturnType< $shm_showcase_table['entry_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_showcase_table_4 = $mol_type_enforce<
		ReturnType< $shm_showcase_table['entry_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $shm_showcase_preview__entry_id_shm_showcase_table_5 = $mol_type_enforce<
		ReturnType< $shm_showcase_table['preview_id'] >
		,
		ReturnType< $shm_showcase_preview['entry_id'] >
	>
	export class $shm_showcase_table extends $mol_grid {
		cell_column( id: any): string
		cell_content( id: any): readonly(any)[]
		entry_title( id: any): string
		entry_arg( id: any): Record<string, any>
		preview_id( id: any): string
		entries( ): readonly(any)[]
		row_height( ): number
		col_ids( ): readonly(any)[]
		Cell_text( id: any): $mol_grid_cell
		Name( id: any): $mol_link
		Preview( id: any): $shm_showcase_preview
	}
	
}

//# sourceMappingURL=table.view.tree.d.ts.map